"use client";

import { FaChevronLeft, FaCheck } from "react-icons/fa";
import { useSettingsStore, LANGUAGES } from "@/lib/settings";

interface LanguagesScreenProps {
  onBack: () => void;
}

export default function LanguagesScreen({ onBack }: LanguagesScreenProps) {
  const { settings } = useSettingsStore();
  const selectedLanguage = settings.language;

  return (
    <div className="h-full bg-background text-foreground flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-background border-b border-border">
        <button onClick={onBack} className="p-2">
          <FaChevronLeft className="text-blue-400 text-xl" />
        </button>
        <h1 className="text-xl font-medium text-foreground">Languages</h1>
        {/* Empty div for spacing */}
        <div className="w-10"></div>
      </div>

      {/* Language List */}
      <div className="flex-1 overflow-y-auto">
        {/* Supported Languages Section */}
        <div className="px-4 pt-4 pb-4">
          <h2 className="text-muted-foreground text-sm uppercase font-medium mb-3 tracking-wide">
            SUPPORTED LANGUAGES
          </h2>
          <div className="space-y-0.5">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.id}
                disabled={!lang.enabled}
                aria-disabled={!lang.enabled}
                className={`settingsLineView ${
                  lang.enabled ? "" : "opacity-45 cursor-not-allowed"
                }`}
              >
                <span className="flex items-center gap-2 text-base font-medium">
                  <span>{lang.flag}</span>
                  <span>{lang.name}</span>
                </span>
                {lang.enabled ? (
                  selectedLanguage === lang.id && (
                    <FaCheck className="text-blue-400 text-base" />
                  )
                ) : (
                  <span className="text-[11px] uppercase tracking-wide text-muted-foreground border border-border rounded-full px-2 py-0.5">
                    Soon
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Lock notice */}
          <p className="text-[11px] text-muted-foreground mt-4">
            Language switching is locked while translations are in progress.
            English is used everywhere for now.
          </p>
        </div>

        {/* Bottom padding for scroll */}
        <div className="h-20" />
      </div>
    </div>
  );
}